import { rem } from 'polished'
import styled from 'styled-components'

interface ISavedFiltersFormStyledProps {}

export const SavedFiltersFormStyled = styled.div<ISavedFiltersFormStyledProps>`
  font-size: ${rem(16)};
`
